import { render, staticRenderFns } from "./dayMilkTable.vue?vue&type=template&id=5cecd9d1&scoped=true"
import script from "./dayMilkTable.vue?vue&type=script&lang=js"
export * from "./dayMilkTable.vue?vue&type=script&lang=js"
import style0 from "./dayMilkTable.vue?vue&type=style&index=0&id=5cecd9d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecd9d1",
  null
  
)

export default component.exports